import { useTranslation } from '@mint-lib/i18n';
import { Download, Import, Upload } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import { ImportPlanViews } from '../../../../../../../types/import.types.js';

type ImportModalFooterProps = {
  activeView: ImportPlanViews;
  isPending: boolean;
  isImportButtonDisabled: boolean;
  isDownloadTemplateDisabled: boolean;
  handleDownloadTemplateButton: () => void;
  handleUploadNewFileButton: () => void;
  handleDownloadErrorLog: () => void;
  handleImport: () => void;
  handleOpenChange: (isOpen: boolean) => void;
};

export const ImportModalFooter = ({
  activeView,
  isPending,
  isImportButtonDisabled,
  isDownloadTemplateDisabled,
  handleDownloadTemplateButton,
  handleUploadNewFileButton,
  handleDownloadErrorLog,
  handleImport,
  handleOpenChange,
}: ImportModalFooterProps) => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <div className="flex w-full justify-between">
      {activeView === ImportPlanViews.UPLOAD && (
        <Button
          disabled={isDownloadTemplateDisabled}
          variant="text"
          onClick={handleDownloadTemplateButton}
          data-dd-action-name="Import activity modal: download template"
        >
          <Download />
          {t('Download template (.xlsx)')}
        </Button>
      )}
      {activeView === ImportPlanViews.ERROR && (
        <div className="flex gap-2">
          <Button
            variant="outlined"
            onClick={handleUploadNewFileButton}
            data-dd-action-name="Import activity modal: upload new file"
          >
            <Upload />
            {t('Upload new file')}
          </Button>
          <Button
            variant="text"
            onClick={handleDownloadErrorLog}
            data-dd-action-name="Import activity modal: download error log"
          >
            <Download />
            {t('Download error log')}
          </Button>
        </div>
      )}
      <div className="ml-auto flex gap-2">
        <Button
          disabled={isPending}
          onClick={() => handleOpenChange(false)}
          variant="text"
          data-dd-action-name="Import activity modal: cancel"
        >
          {t('Cancel')}
        </Button>

        <Button
          onClick={handleImport}
          disabled={isImportButtonDisabled}
          data-dd-action-name="Import activity modal: import"
        >
          <Import />
          {t('Import')}
        </Button>
      </div>
    </div>
  );
};
